import React, { Component, useState } from 'react'
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import moment from "moment";
import { MdEdit, MdListAlt } from "react-icons/md"

import JobService from "../../Services/JobService";
import { revenuecostService } from '../../Services/revenuecostService'
import { DeleteItem } from "../../Components/Modal";
import { toast } from "react-toastify";

import EnquiryService from "../../Services/EnquiryService";

class AssignAdvancePayment extends Component {
    state = {
        jobList: [],
        openModal:false,
        loader:false,
        rowData:{}
    }

    componentDidMount() {
        this.getJobList()
        this.signInIntuit()
    }

    getJobList = () => {
        let param = {};
        param["limit"] = 1000;
        param["page"] = 1;

        JobService.getAdvanceInvoiceJob(param).then(result => {
            if (result.status === true) {
                this.setState({ jobList: result.data })
            }
        })
    }

    signInIntuit = () => {
        var win;
        var parameters = "location=1,width=800,height=650";
        parameters += ",left=" + (window.innerWidth - 800) / 2 + ",top=" + (window.innerHeight - 650) / 2;

        revenuecostService.qbookAuth().then(result => {
            // Launch Popup
            // win = window.open(result, 'connectPopup', parameters);
            // this.props.history.push(result)
            if (!result.status) {
                localStorage.setItem('redirectUri', window.location.href)
                window.location.href = result.uri
            }

        })

    }

     onModalSubmit = () => {
        let deleteData = {
            quote_token: this.state.openModal,
        };
         console.log("deleteData ===> ", deleteData);
         console.log("deleteData ===> ", this.state.rowData);
         const { qbInvoiceId, invoiceId, amount, qbCustId } = this.state
         const query = new URLSearchParams(this.props.location.search);
         let jobId = query.get('id')
 
         let invoiceReq = {
             qbCustId,
             totalAmt: amount,
             qbInvoiceId,
             jobId
         }
         
         revenuecostService.invoicePayment(invoiceReq).then(invoiceRes => {
             if (invoiceRes.status === true) {
                 let postData = {
                     id: invoiceId,
                     amount: amount
                 }
                 revenuecostService.updateStatus(postData).then(result => {
                     if (result.status === true) {
                         this.getJobList()
                         this.handleShow(false)
                         toast.success(invoiceRes.message);
                     } else { 
                         toast.error(invoiceRes.message) 
                     }
                 })
             } else { 
                 toast.error(invoiceRes.message) 
             }
         })         

        // EnquiryService.cancelEnquiry(deleteData).then((res) => {
        //     if (res.status === true) {
        //         this.getJobList();
        //         toast.success("Cancelled Successfully")
        //        this.setState({openModal:false})
        //     } else {
        //         toast.error(res.message)
        //         this.setState({openModal:false})
        //     }
        // })
    }
    render() {
      


        const { jobList } = this.state
        // console.log("=======", jobList);
        return (
            <Card>
                <Card.Body>
                    <Row>
                        <Col>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Job Id</th>
                                        <th>Customer Name</th>
                                        <th>Aggred Amount</th>
                                        <th>Advance Amount</th>
                                        {/* <th>Date</th> */}
                                        <th>Balance</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        jobList.map((item, index) => {
                                            let total = item.invoice_details.reduce(function (sum, amt) {
                                                return sum + amt.balance;
                                            }, 0);
                                            return (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item.jobToken}</td>
                                                    <td>{item.custName}</td>
                                                    <td>{item.amount}</td>
                                                    <td>{item.job_advance_payment}</td>
                                                    {/* <td>{moment(item.dateAt).format("YYYY-MM-DD")}</td> */}
                                                    <td>{total}</td>
                                                    <td>
                                                        <Button
                                                            className="pointer"
                                                            color="red"
                                                            size="25px"
                                                            onClick={() =>
                                                                this.setState({openModal:true,rowData:item})
                                                            }
                                                        >Pay</Button>
                                                        {/* onClick={() => this.handlePay(index, item.qbInvoiceId, item._id, item.qbCustId)} */}
                                                        {/* <MdListAlt
                                                        className="pointer"
                                                        onClick={() => this.props.history.push(`invoice-by-job?id=${item._id}`)}
                                                        color="#0323fe"
                                                        size="25px"
                                                    /> */}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }


                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {Boolean(this.state.openModal) && (
                        <DeleteItem
                            isOpen={Boolean(this.state.openModal)}
                            title="Assign Payment"
                            message={`Are you sure want to assign payment?`}
                            onSubmitEvent={() => this.onModalSubmit()}
                            handleClose={() => this.setState({openModal:false,rowData:{}})}
                        />
                    )}
                </Card.Body>
            </Card>

        )
    }
}

export { AssignAdvancePayment }